import { subDays } from 'date-fns';

import { date } from '@/utils/filters';

const mutations = {
  SET_PAGE_SIZE(state, { pageSize }) {
    state.pageSize = pageSize;
    state.currentPage = 0;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },

  SET_ORDERING(state, { ordering }) {
    state.ordering = ordering;
    state.currentPage = 0;
  },

  SET_COUNT(state, count) {
    state.count = count;
  },

  SET_LESSON_HISTORY_REPORT(state, report) {
    state.lessonHistoryItems = report;
  },

  SET_LESSON_SUMMARY(state, report) {
    state.lessonSummaryItems = report;
  },

  SET_SEARCH_QUERY(state, query) {
    state.filters = {
      ...state.filters,
      query,
    };
  },

  SET_DATE_RANGE(state, dateRange) {
    state.dateRange = dateRange;
  },

  RESET_DATE_RANGE(state) {
    state.dateRange = {
      start: date(subDays(new Date(), 30)),
      end: date(new Date()),
    };
  },

  RESET_FILTERS: state => {
    state.filters = {
      query: null,
    };
  },

  RESET_PAGINATION: state => {
    state.currentPage = 0;
    state.pageSize = 15;
    state.ordering = null;
  },
};

export default mutations;
